import { connect } from 'react-redux'
import { getBids } from 'utils/actions/bids'
import { openDialog } from 'utils/actions/ui'
import { Table } from './Table'

export const OptionsTable = connect(
  state => {
    const {
      bids: { bidsAreLoading, bidsCountList, bidsList },
      sidebar: { activeRowId: shipmentId },
    } = state
    return {
      bidsCountList,
      bidsList,
      bidsAreLoading,
      shipmentId,
    }
  },
  dispatch => ({
    refreshBids: id => dispatch(getBids(id)),
    openBookingDialog: () => dispatch(openDialog()),
  })
)(Table)
